/**
 *
 */
(function () {
  'use strict';
  angular.module('cbl.finanza.mf').factory('FinMessaggiFctr', [
    'CblMessageSrvc',
    'FinLabelSrvc',
    'FinLoggerSrvc',
    '$timeout',
    function (messaggiSrvc, labelSrvc, loggerSrvc, $timeout) {
      
      var processaResponse = function (response) {
        if (!response) {
          var message = {
            message: 'Undefined Error - Missing response'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = false;
        if (response.data && response.data.messageList) {
          if (response.data.messageList.errMessages.length) {
            for (var i in response.data.messageList.errMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.errMessages[i].message
              );
            }
            hasError = response.data.messageList.errMessages.length > 0;
          }
          if (response.data.messageList.fatMessages.length) {
            for (var j in response.data.messageList.fatMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.fatMessages[j].message
              );
            }
            hasError = response.data.messageList.fatMessages.length > 0;
          }
          if (response.data.messageList.warMessages.length) {
            for (var k in response.data.messageList.warMessages) {
              messaggiSrvc.pushWarningMessage(
                response.data.messageList.warMessages[k].message
              );
            }
          }
          if (response.data.messageList.infMessages.length) {
            for (var z in response.data.messageList.infMessages) {
              messaggiSrvc.pushInfoMessage(
                response.data.messageList.infMessages[z].message
              );
            }
          }
        }
        if (response.status > 399) {
          hasError = true;
          if (angular.isString(response.data)) {
            // Errori DotNet
            try {
              var messages = JSON.parse(response.data).Messages;
              for (var x in messages) {
                messaggiSrvc.pushErrorMessage(messages[x].Message);
              }
            } catch (e) {
              messaggiSrvc.pushErrorMessage(
                "Si è verificato un errore, contattare l'assistenza"
              );
            }
          } else {
            var messageHttp = {
              message: 'Error ' + response.status + ' ' + response.statusText
            };
            messaggiSrvc.pushErrorMessage(messageHttp.message);
          }
        }
        return hasError;
      };
      
      /**
       * 
       * @param {*} response 
       * @returns boolean
       * @description Processa la response come processaResponse() ma nel caso dei warning non li fa mostrare nel pop-up
       */
      var processaResponseErroriForzabili = function(response){
        if (!response) {
          var message = {
            message: 'Undefined Error - Missing response'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = false;
        if (response.data && response.data.messageList) {
          if (response.data.messageList.errMessages.length) {
            for (var i in response.data.messageList.errMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.errMessages[i].message
              );
            }
            hasError = response.data.messageList.errMessages.length > 0;
          }
          if (response.data.messageList.fatMessages.length) {
            for (var j in response.data.messageList.fatMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.fatMessages[j].message
              );
            }
            hasError = response.data.messageList.fatMessages.length > 0;
          }
          if (response.data.messageList.infMessages.length) {
            for (var z in response.data.messageList.infMessages) {
              messaggiSrvc.pushInfoMessage(
                response.data.messageList.infMessages[z].message
              );
            }
          }
        }
        if (response.status > 399) {
          hasError = true;
          if (angular.isString(response.data)) {
            // Errori DotNet
            try {
              var messages = JSON.parse(response.data).Messages;
              for (var x in messages) {
                messaggiSrvc.pushErrorMessage(messages[x].Message);
              }
            } catch (e) {
              messaggiSrvc.pushErrorMessage(
                "Si è verificato un errore, contattare l'assistenza"
              );
            }
          } else {
            var messageHttp = {
              message: 'Error ' + response.status + ' ' + response.statusText
            };
            messaggiSrvc.pushErrorMessage(messageHttp.message);
          }
        }
        return hasError;
      };

      var processaCabelAlertResponse = function(response){
        if (!response) {
          var message = {
            message: 'Undefined Error - Missing response'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = response.data.bloccoOperativitaEffettivo;
        if(response.data && response.data.listaAlert && hasError){
          //PROCESSO WARNING MESSAGE
          response.data.listaAlert.forEach(function(alert) {
            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Warning' ){
              messaggiSrvc.pushWarningMessage(alert.testo);
            }
          });
          //PROCESSO ERRROR MESSAGES
          response.data.listaAlert.forEach(function(alert) {
            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Error' ){
              messaggiSrvc.pushErrorMessage(alert.testo);

            }
          });
        }else if(response.data && response.data.listaAlert && !hasError){
          response.data.listaAlert.forEach(function(alert) {
            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Warning' ){
              messaggiSrvc.pushWarningMessage(alert.testo);
            }
          });
          //PROCESSO ERRROR MESSAGES
          response.data.listaAlert.forEach(function(alert) {
            if(alert.livelloGravitaSpecified && alert.livelloGravita === 'Error' ){
              messaggiSrvc.pushWarningMessage(alert.testo);

            }
          });
        }
        if(response.status > 399){
          hasError = true;
          var messageHttp = {
            message: 'Error ' + response.status + ' ' + response.statusText
          };
          messaggiSrvc.pushErrorMessage(messageHttp.message);
        }
        
        return hasError;
      };
      var addMessage = function (message) {
        if (message.type === 'E' || message.type === 'F') {
          messaggiSrvc.pushErrorMessage(message.message);
          // console.error(message.message);
        } else if (message.type === 'W') {
          messaggiSrvc.pushWarningMessage(message.message);
          // console.warning(message.message);
        } else {
          messaggiSrvc.pushInfoMessage(message.message);
        }
      };

      var resetMessages = function () {
        messaggiSrvc.reset();
      };

      var processaForm = function (form) {
        if (form.$valid) {
          return true;
        }
        this.validaForm(form);
        var message = null;
        for (var label in form.$error.required) {
          message = {
            type: 'E',
            message:
              form.$error.required[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.obbligatorio')
          };
          this.addMessage(message);
        }
        for (var labelMax in form.$error.max) {
          message = {
            type: 'E',
            message:
              form.$error.max[labelMax].$name +
              ': ' +
              labelSrvc.getLabel('validazione.valore.massimo')
          };
          this.addMessage(message);
        }
        for (var labelNmb in form.$error.number) {
          message = {
            type: 'E',
            message:
              form.$error.number[labelNmb].$name +
              ': ' +
              labelSrvc.getLabel('validazione.numerico')
          };
          this.addMessage(message);
        }
        for (var labelMin in form.$error.min) {
          message = {
            type: 'E',
            message:
              form.$error.number[labelMin].$name +
              ': ' +
              labelSrvc.getLabel('validazione.valore.minimo')
          };
          this.addMessage(message);
        }
        return false;
      };

      var validaForm = function (form) {
        this.resetMessages();
        var valid = true;
        var message = null;
        var label = null;
        for (label in form.$error.pattern) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.pattern[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.formato')
          };
          this.addMessage(message);
        }
        for (label in form.$error.cblMax) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.cblMax[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.massimo')
          };
          this.addMessage(message);
        }
        for (label in form.$error.cblMin) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.cblMin[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.minimo')
          };
          this.addMessage(message);
        }
        for (label in form.$error.cblPrecisione) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.cblPrecisione[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.precisione')
          };
          this.addMessage(message);
        }
        for (label in form.$error.maxlength) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.maxlength[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.maxlength')
          };
          this.addMessage(message);
        }
        for (label in form.$error.minlength) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.minlength[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.minlength')
          };
          this.addMessage(message);
        }
        for (label in form.$error.maxDate) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.maxDate[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.maxdate')
          };
          this.addMessage(message);
        }
        for (label in form.$error.minDate) {
          valid = false;
          message = {
            type: 'E',
            message:
              form.$error.minDate[label].$name +
              ': ' +
              labelSrvc.getLabel('validazione.mindate')
          };
          this.addMessage(message);
        }
        return valid;
      };

      var chiudiLoaderBrio = function () {
        $timeout(function () {
          try {
            CblBrioLoader.hideLoader();
          } catch (e) {}
        }, 100);
      };

      var scroll = function (id) {
        var headerMarg = parseInt(
          angular.element('.navbar-fixed-top').css('margin-top')
        );
        if (isNaN(headerMarg)) {
          headerMarg = 0;
        }
        var diffScroll =
          angular.element('.navbar-fixed-top').height() +
          headerMarg +
          angular.element('#prodConvBox').height();
        var scrollPoint = angular.element(id).offset().top - diffScroll;
        angular.element('body,html').animate(
          {
            scrollTop: scrollPoint
          },
          500
        );
      };

      return {
        processaResponse: processaResponse,
        processaCabelAlertResponse: processaCabelAlertResponse,
        processaResponseErroriForzabili:processaResponseErroriForzabili,
        addMessage: addMessage,
        resetMessages: resetMessages,
        processaForm: processaForm,
        validaForm: validaForm,
        scroll: scroll,
        chiudiLoaderBrio: chiudiLoaderBrio
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finMessaggiFctr.js
 ** module id = 24
 ** module chunks = 0 1 2
 **/